module.exports = __webpack_public_path__ + "media/images/riders/HENRIQUE_AVANCINI-dce29cbb31a977e1b4fece95650f8925.png";